const addPlayerInstance = (orderNumber: string, customerId: string) => {
  if (document.getElementById('cliplister-script')) {
    if (document.getElementById('cliplister-instance')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const instanceToRemove = document.getElementById('cliplister-instance');
      instanceToRemove?.remove();
    }
    const playerInstance = document.createElement('script');
    playerInstance.setAttribute('id', 'cliplister-instance');
    playerInstance.type = 'text/javascript';
    playerInstance.text = `
    var clViewer = new Cliplister.Viewer({
      parentId: "cliplister-viewer-${orderNumber}",
      customer: ${customerId},
      assetKeys: ["${orderNumber}"],
      keyType: 10000,
      stage: {
        width: "100%",
        aspectRatio: "asset"
      },
      plugins: {
        ClickableVideo: {
            layer: 1
        },
        InnerControls: {
            layer: 2,
            id: "controls",
            blacklist: ["share","quality","playback-speed"],
            template: {
                type: "external",
                source: "https://mycliplister.com/static/viewer/assets/skins/default/controls.html"
            }
        },
        BufferingSpinner: {
            layer: 3,
            width: 50,
            height: 50
        },
        PreviewImage: {
            layer: 4
        },
        PlayButton: {
            id: "playButton",
            layer: 5,
            image: 'https://mycliplister.com/static/viewer/assets/skins/default/playButton.png',
            width: 100,
            height: 100
        }
      }
    });
    `;
    // append player instance directly after cliplister-script
    const appendTo = document.getElementById('cliplister-script');
    appendTo.parentNode.insertBefore(playerInstance, appendTo.nextSibling);
  }
};

export default addPlayerInstance;
